export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/lock-wall.897a4f50.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};